import axios from "axios";
import { baseUrl } from "../Environments/environment";

const supportBase = `${baseUrl}/customerSupport`;

export const searchSupportBusiness = async (query) => {
  const response = await axios.get(
    `${supportBase}/business/search?query=${encodeURIComponent(query)}`,
    { withCredentials: true },
  );
  return response.data.result;
};

export const getSupportBusinessDetails = async (placeId) => {
  const response = await axios.get(
    `${supportBase}/business/details?place_id=${encodeURIComponent(placeId)}`,
    { withCredentials: true },
  );
  return response.data.result;
};

export const createSupportConversation = async (customerData) => {
  const response = await axios.post(`${supportBase}/customer/new`, customerData, {
    withCredentials: true,
  });
  return response.data.result;
};

export const getCustomerConversation = async (code) => {
  const response = await axios.get(
    `${supportBase}/customer/conversation/${code}`,
    { withCredentials: true },
  );
  return response.data.result;
};

export const sendCustomerMessage = async (code, content) => {
  const response = await axios.post(
    `${supportBase}/customer/conversation/${code}/messages`,
    { content },
    { withCredentials: true },
  );
  return response.data.result;
};
